import React from 'react';
import { useTranslation } from 'react-i18next';

import Form  from '../../Form/Form';

interface LoginProps {
  close: () => void
}

function Login({ close }: LoginProps) {
  const { t } = useTranslation('common');

  const steps = [
    {
      inputs: [
        {
          type: 'text',
          className: 'full-width',
          label: t('form.usernameLabel'),
          name: 'username',
          placeholder: t('form.usernamePlaceholder'),
          required: true
        },
        {
          type: 'password',
          className: 'full-width',
          label: t('form.passwordLabel'),
          name: 'password',
          placeholder: t('form.passwordHolder'),
          required: true
        },
        {
          type: 'checkbox',
          className: 'full-width',
          label: t('form.remember'),
          name: 'remember'
        }
      ],
      buttons: [
        {
          className: 'modal-submit',
          type: 'submit',
          label: t('form.loginButton')
        }
      ],
      links: [
        {
          text: t('form.loginForgotPassword'),
          action: 'forgot-password',
          className: 'full-width',
          decoration: true
        },
        {
          text: t('form.loginRegister'),
          action: 'register',
          hasButton: true
        }
      ]
    }
  ];

  return (
    <Form
      containerClass="login-form"
      steps={ steps }
      close={ close }
    />
  );
}

export default Login;
